import { appFeature } from 'modules/organizer/domain/interfaces/available-feature';
import { TournamentPlan, TournamentPlanFeature } from 'modules/organizer/domain/interfaces/tournament-plan';

export interface TournamentPlanFeatureDto {
  id: number;
  feature: appFeature;
}

export interface TournamentPlanDto {
  id: number;
  name: string;
  priceInMinorUnits: number;
  period: TournamentPlan['period'];
  features?: TournamentPlanFeatureDto[];
  createdAt?: string;
}

export function mapTournamentPlanFeature(dto: TournamentPlanFeatureDto): TournamentPlanFeature {
  return {
    id: dto.id,
    feature: dto.feature,
  };
}

export function mapTournamentPlan(dto: TournamentPlanDto): TournamentPlan {
  return {
    id: dto.id,
    name: dto.name,
    priceInMinorUnits: dto.priceInMinorUnits,
    period: dto.period,
    features: (dto.features ?? []).map(mapTournamentPlanFeature),
    createdAt: dto.createdAt ?? '',
  };
}
